import { render, staticRenderFns } from "./RiskAssessmentStdDoc.vue?vue&type=template&id=418b935e&scoped=true"
import script from "./RiskAssessmentStdDoc.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentStdDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b935e",
  null
  
)

export default component.exports